import {
  Box,
  Button,
  Collapse,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllStudents } from "../../../redux/Actions/StudentAdminAction"; // Import the action
import AdminNavbar from "./AdminNavbar"; // Assuming AdminNavbar component exists

const StudentAdminPage = () => {
  const dispatch = useDispatch();

  // Access the state from Redux for all students
  const {
    allStudents = [],
    loading,
  } = useSelector((state) => state.studentAdmin);

  // Local state for collapsing tables
  const [showAllStudents, setShowAllStudents] = useState(true); // Set it to true initially for debugging
  const [showEnrolledStudents, setShowEnrolledStudents] = useState(true); // Same for debugging

  // Hardcoded data for enrolled students
  const enrolledStudents = [
    {
      firstName: "Alice",
      lastName: "Johnson",
      dob: "1997-09-10",
      accommodation: "On Campus",
      courses: [
        { title: "Mathematics", level: "Beginner" },
        { title: "English Literature", level: "Intermediate" },
      ],
    },
    {
      firstName: "Bob",
      lastName: "Williams",
      dob: "1996-05-05",
      accommodation: "Off Campus",
      courses: [{ title: "Physics", level: "Advanced" }],
    },
  ];

  // Fetch the "All Students" data when the component mounts
  useEffect(() => {
    dispatch(fetchAllStudents());
  }, [dispatch]);

  return (
    <div className="admin-dashboard-layout">
      <AdminNavbar /> {/* Admin navigation */}
      <Container>
        <Box sx={{ my: 4, textAlign: "center" }}>
          {/* Centered Student Management header */}
          <Typography variant="h4" gutterBottom>
            Student Management
          </Typography>

          {/* Button for showing/hiding all students */}
          <Box sx={{ mb: 2 }}>
            <Button
              variant="contained"
              onClick={() => setShowAllStudents(!showAllStudents)}
              sx={{ marginBottom: 2 }}
            >
              {showAllStudents ? "Hide All Students" : "Show All Students"}
            </Button>
          </Box>

          {/* Collapse for All Students */}
          <Collapse in={showAllStudents}>
            {/* Directly check if students exist */}
            {loading && <Typography>Loading...</Typography>}
            {/* {error && <Typography color="error">Error: {error}</Typography>}*/}
            {!loading && allStudents.length > 0 ? (
              <Box sx={{ my: 2 }}>
                <Typography variant="h6" gutterBottom>
                  All Students
                </Typography>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          First Name
                        </TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Last Name
                        </TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>Email</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Date of Birth
                        </TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>Job</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Nationality
                        </TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Accommodation
                        </TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Phone Number
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {allStudents.map((student) => (
                        <TableRow key={student.studentId}>
                          <TableCell>{student.firstName}</TableCell>
                          <TableCell>{student.lastName}</TableCell>
                          <TableCell>{student.email}</TableCell>
                          <TableCell>
                            {new Date(student.dateOfBirth).toLocaleDateString()}
                          </TableCell>
                          <TableCell>{student.job}</TableCell>
                          <TableCell>{student.nationality}</TableCell>
                          <TableCell>{student.accommodation}</TableCell>
                          <TableCell>{student.phoneNumber}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            ) : (
              !loading && <Typography>No students found.</Typography>
            )}
          </Collapse>

          {/* Button for showing/hiding enrolled students */}
          <Box sx={{ mt: 4 }}>
            <Button
              variant="contained"
              onClick={() => setShowEnrolledStudents(!showEnrolledStudents)}
            >
              {showEnrolledStudents
                ? "Hide Enrolled Students"
                : "Show Enrolled Students"}
            </Button>
          </Box>

          {/* Collapse for Enrolled Students */}
          <Collapse in={showEnrolledStudents}>
            <Box sx={{ my: 2 }}>
              <Typography variant="h6" gutterBottom>
                Enrolled Students
              </Typography>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>First Name</TableCell>
                      <TableCell>Last Name</TableCell>
                      <TableCell>Date of Birth</TableCell>
                      <TableCell>Accommodation</TableCell>
                      <TableCell>Courses</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {enrolledStudents.map((student, index) => (
                      <TableRow key={index}>
                        <TableCell>{student.firstName}</TableCell>
                        <TableCell>{student.lastName}</TableCell>
                        <TableCell>{student.dob}</TableCell>
                        <TableCell>{student.accommodation}</TableCell>
                        <TableCell>
                          {student.courses.map((course, i) => (
                            <Box key={i}>
                              {course.title} - {course.level}
                            </Box>
                          ))}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Collapse>
        </Box>
      </Container>
    </div>
  );
};

export default StudentAdminPage;
